import axios from "axios";
import { USER_TYPES } from "@upsolve/shared";
import { get } from "lodash";

export default async function newsletterSignup(email) {
  return axios.post(`${UPSOLVE_API_URL}/v1/auth/register`, {
    user: {
      email,
    },
    type: USER_TYPES.FILER,
    segment: {
      anonymousId: get(window, "analytics.user") != null ? window.analytics.user().anonymousId() : undefined,
      traits: get(window, "analytics.user") != null ? window.analytics.user().traits() : undefined,
    },
  });
}
